import { render, staticRenderFns } from "./MejoraRegulatoria2025.vue?vue&type=template&id=6317a14c&"
import script from "./MejoraRegulatoria2025.vue?vue&type=script&lang=js&"
export * from "./MejoraRegulatoria2025.vue?vue&type=script&lang=js&"
import style0 from "./MejoraRegulatoria2025.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports